import { render, staticRenderFns } from "./aifunc.vue?vue&type=template&id=19915e0e&scoped=true"
import script from "./aifunc.vue?vue&type=script&lang=js"
export * from "./aifunc.vue?vue&type=script&lang=js"
import style0 from "./aifunc.vue?vue&type=style&index=0&id=19915e0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19915e0e",
  null
  
)

export default component.exports